import i18next from 'i18next';

i18next.addResources('es_CL', 'OrderForm', {
  required: 'Requerido',
  confirm: 'Confirmar',
  name: 'Nombre',
  email: 'Correo electrónico',
  phone: 'Número de teléfono'
});
